export default {
    key2StatusToOrigoStatus(status, delivered) {
        switch (status.toLowerCase()) {
            case 'suppliers added':
            case 'request for pricing sent':
                return 'SUBMITTED';
            case 'order placed':
            case 'placing with dealer':
                return 'APPROVED';
            case 'order accepted':
                return 'ORDERED';
            case 'stock':
            case 'delivery offered':
                return 'INSTOCK';
            case 'delivery arranged':
            case 'vehicle implemented':
            case 'contract implemented':
                return 'DELIVERING';
            case 'implemented':
                // This applies if status is implemented and delivery data is in the past
                return delivered ? 'DELIVERED' : 'DELIVERING';
            default:
                console.log('key2 status - Unknown status: ' + status);
                return 'UNKNOWN';
        }
    },

    origoStatusToStatusTitle(status) {
        switch (status) {
            case 'SUBMITTED':
                return 'Quote submitted';
            case 'APPROVED':
                return 'Request approved';
            case 'ORDERING':
                return 'Placing with dealer'
            case 'ORDERED':
                return 'Vehicle on order';
            case 'INSTOCK':
                return 'Arrived in stock';
            case 'DELIVERING':
                return 'Delivery organised';
            case 'DELIVERED':
                return 'Vehicle delivered';
            default:
                console.log('status title - Unknown status: ' + status);
                return "Order being processed";
        }
    },

    hasProgressedToStage(stage, currentStatus) {
        switch (stage) {
            case 'Order Submitted':
                if (
                    currentStatus === 'Supplier Added' ||
                    currentStatus === 'Suppliers Added' ||
                    currentStatus === 'Preferred Supplier Selected' ||
                    currentStatus === 'Order Placed' ||
                    currentStatus === 'Order Accepted' ||
                    currentStatus === 'Stock' ||
                    currentStatus === 'Delivery Offered' ||
                    currentStatus === 'Delivery Arranged' ||
                    currentStatus === 'Contract Implemented' ||
                    currentStatus === 'Implemented'
                ) {
                    return true;
                }
                break;
            case 'Order Confirmed':
                if (
                    currentStatus === 'Order Placed' ||
                    currentStatus === 'Order Accepted' ||
                    currentStatus === 'Stock' ||
                    currentStatus === 'Delivery Offered' ||
                    currentStatus === 'Delivery Arranged' ||
                    currentStatus === 'Contract Implemented' ||
                    currentStatus === 'Implemented'
                ) {
                    return true;
                }
                break;
            case 'Vehicle has arrived in stock':
                if (
                    currentStatus === 'Delivery Offered' ||
                    currentStatus === 'Delivery Arranged' ||
                    currentStatus === 'Contract Implemented' ||
                    currentStatus === 'Implemented'
                ) {
                    return true;
                }
                break;
            case 'Delivery Organised':
            case 'Delivery Arranged':
                if (
                    currentStatus === 'Delivery Arranged' ||
                    currentStatus === 'Contract Implemented' ||
                    currentStatus === 'Implemented'
                ) {
                    return true;
                }
                break;
            case 'Delivered':
                if (
                    currentStatus === 'Implemented'
                ) {
                    return true;
                }
                break;
            default:
                return false;

        }

        return false;
    }
}
